import { ChangelogUpdateModel } from "types";

export const ROADMAP: string[] = [
  "<strong>More planets</strong>: Planets will each focus on a particular base stat. Ex: If you want the best antimatter upgrades, you'll want to hit up the antimatter planet (Seneca)",
  "<strong>More mobs and drops</strong>: Each planet will be filled with mobs across all medallion levels with a vast variety of drops with interesting stat combos.",
  "<strong>Reroll/Prestige system</strong>: You'll be able to reroll and be promoted in rank. As you climb up each rank tier,  you'll get rewards to create some ridiculously powerful builds as well as new interesting game dynamics.",
  "<strong>Missions</strong>: Fun story-based missions with unique rewards",
  "<strong>Multi-ship battles</strong>: You'll be able to build a small party of ships/pilots to fight in 2v2 battles, increasing the strategic complexity of each fight",
];

export const CHANGELOG: ChangelogUpdateModel[] = [
  {
    name: "Comparison is the Thief of annoying UI",
    date: new Date("7-13-25"),
    changes: [
      "Now in the Build Ship screen at a Loadout Hub, when you hover over an upgrade, you can see the exact stat changes that will happen if you install it",
    ],
  },
  {
    name: "Sharing is Caring Part Deux",
    date: new Date("7-13-25"),
    changes: [
      "You can now train skills from a different pilot profession than your own, at a higher medallion cost. Thanks Klein for the suggestion!",
      "Finally combined Ship Build and Pilot Skills screens into one building: the Loadout Hub (previously Shipworks). What was previously the Pilot Guild is now the Fleet Control, which is where you go to switch your ship or pilot",
    ],
  },
  {
    name: "Sharing is Caring",
    date: new Date("7-11-25"),
    changes: [
      "Decided to move back to a shared pool for stats and skills (for both players and mobs), to put more strategy into trade offs",
      "Skills now recharge at the start of each battle for both players and mobs, to hopefully add more tactical depth to battles, rather than only one shot wins. Also, faster recharge is now a more important stat to consider",
      "Mobs now use their skills immediately if they have them available, rather than the previous 50/50 chance of using them",
      "Build screen at Shipworks now combines stats and upgrades to make upgrading your ship a lot less clunky",
    ],
  },
  {
    name: "No Money, Hopefully No Problems",
    date: new Date("7-9-25"),
    changes: [
      "Removed the concept of an inventory, so you no longer need to buy and sell items, which was an annoying process",
      "No more repair items (or items at all), you now heal fully after every battle. This was done to put more emphasis on your ship/pilot build instead of using basically potions as a crutch",
      "Given that credits just weren't very useful, those have been removed as well",
      "Hoping these changes eliminate superfluous parts of the gameplay loop, making the game more focused and fun!",
    ],
  },
  {
    name: "Online Players Update",
    date: new Date("7-3-25"),
    changes: [
      "Changed the way other players are shown, so that the mechanism is more efficient and less resource intensive",
      "Removed the big list of online players in the Network tab",
      "Added more functionality to the chat, so you can click into player details as well as see medallion counts",
    ],
  },
  {
    name: "Storage Wars",
    date: new Date("6-23-25"),
    changes: [
      "Added a new storage system for upgrades, to clean up your inventory and make it easier to manage your upgrades for installation.",
    ],
  },
  {
    name: "Tyrannosaurus Reqs",
    date: new Date("6-16-25"),
    changes: [
      "Added some quality of life updates to the base stats enhancement flow. Now you can decrease a base stat 1 at a time instead of needing to reset all of it. You can now also see the stat requirements of installed upgrades that will get uninstalled if you reduce a stat too much.",
    ],
  },
  {
    name: "End Level",
    date: new Date("6-15-25"),
    changes: [
      "Levels and experience are no longer. Progression is solely through medallions, which are now directly gained through battles",
      "Stats and skills now use medallions independently, so you don't have to make trade offs between them anymore",
      "Removed the need to pay credits to reset stats and skills",
    ],
  },
  {
    name: "The Hottest of Keys",
    date: new Date("6-13-25"),
    changes: [
      "Added keyboard controls for all fight actions: regular attacks, pilot skills, using supplies, and escaping",
    ],
  },
  {
    name: "Core Strengthened",
    date: new Date("6-6-25"),
    changes: [
      "Added a new sector, Meridian, to planet Seneca. Meridian has opponents from level 60-80",
    ],
  },
  {
    name: "Level Up",
    date: new Date("6-4-25"),
    changes: [
      "Adjusted levels of current mobs to be less condensed, so now there is now 5-6 mobs every 20 levels instead of every 10",
      "Fade upgrades that you can't yet install due to stat requirements not being met",
    ],
  },
  {
    name: "Mobile ...Second",
    date: new Date("4-23-25"),
    changes: [
      "Added touch controls and better formatting for mobile devices, so you can play the game on your phone",
      "Sector Link instant travel within a planet functionality is now accessed by clicking on the minimap (which seemed to make sense thematically)",
    ],
  },
  {
    name: "Open Frequency",
    date: new Date("4-21-25"),
    changes: [
      "Added player chat into the Transmission Log, as well as a mini overlay with the latest messages",
      "Also integrated with Discord to have the messages display there as well",
    ],
  },
  {
    name: "Lost in Space",
    date: new Date("4-17-25"),
    changes: [
      "Given the current and planned addition of many more sectors per planet, I added a minimap to help you keep track of where you are on a given planet",
    ],
  },
  {
    name: "Starter Pack",
    date: new Date("4-9-25"),
    changes: [
      "Added a starter set of ship upgrades that new players receive when they finish the battle tutorial with Conway, to make the first few levels less grindy.",
    ],
  },
  {
    name: "Honey I shrunk the filesizes",
    date: new Date("4-6-25"),
    changes: [
      "I realized how heavy the background image assets were getting due to some new 3d effects I was applying, so I redid them and they're a lot smaller now, hopefully no longer crushing your download speeds.",
    ],
  },
  {
    name: "April Tool(tip)'s Day",
    date: new Date("4-1-25"),
    changes: [
      "That was a really good pun title, no one can convince me otherwise",
      "Revamped the tooltip system to be much more dynamic in positioning, they also are now shown properly in scrolling containers now",
      "Tall overlays like the fight preview/fight results are now actually fully scrollable",
      "Now when you lose a battle you're charged double the usual repair fee for a full repair, just to make losing sting a little bit",
      "Depowered Exp Boosters since they were way too cheap",
    ],
  },
  {
    name: "Linked Sectors",
    date: new Date("3-31-25"),
    changes: [
      "Recall Rift is now named Sector Link, and allows you to instantly travel not just to the main city but also to special outpost sectors on any planet",
      "Added a couple small sectors both to Seneca and Bishop that have an express Vector Station building for quick repairs",
      "This update was done in anticipation of adding lots of sectors to each planet and making getting around easier",
    ],
  },
  {
    name: "New sector: Underhaven",
    date: new Date("3-27-25"),
    changes: [
      "Added a new sector on planet Seneca: Underhaven. It has new mobs and drops from levels 30-40",
    ],
  },
  {
    name: "A little spit shine",
    date: new Date("3-16-25"),
    changes: [
      "Added more borders/padding to ship and shop data screens to make them look a little nicer",
    ],
  },
  {
    name: "Taking Inventory",
    date: new Date("3-16-25"),
    changes: [
      "Added a filter to the upgrades inventory list, so you can filter them by enhanced stat",
      "Added a new reactions feature to the Transmissions Log, so you say hi to new players or acknowledge other players' achievements",
    ],
  },
  {
    name: "Some small Quality of life updates",
    date: new Date("3-14-25"),
    changes: [
      "Moved the game message pop ups to the bottom right of the screen and made them smaller, as they were blocking a lot of the screen",
      "Fixed issue with installed upgrades not showing up on Firefox",
      "Clicking on your pilot avatar now opens up your interior ship screen",
      "Removed max level restriction (previously level 5) on switching your ship or pilot, switch away!",
    ],
  },
  {
    name: "A Whole New World",
    date: new Date("3-13-25"),
    changes: [
      "FINALLY, the first new planet is here! Seneca is a planet of floating cities around an Antimatter core, and it's where you'll find the most advanced energy-based ship upgrades in the galaxy.",
    ],
  },
  {
    name: "Thoughts and prizes",
    date: new Date("2-9-25"),
    changes: [
      "Added better drops for Bishop mobs, so that every victory at any battle rating results in an supply/upgrade drop of some kind",
    ],
  },
  {
    name: "All The Small Things",
    date: new Date("1-5-25"),
    changes: [
      "Added hit chance and dodge chance to the stat bar tooltips at the bottom of the battle screen, for both the player and the opponent",
      "When looking at an upgrade's tooltip, there is now a comparison of an its stats against the upgrade you currently have installed",
      "Changed up the XP icon to no longer be an up arrow to add clarity",
    ],
  },
  {
    name: "Thinking Uncritically about Attacks",
    date: new Date("1-4-25"),
    changes: [
      "Battling was mixing a too much chance and variance with strategic decision making, so some big changes were made to how attacks work:",
      "Linear probability on attack damage/dodge/critical hit was removed. Previously, if you had low accuracy against a high evasion defender, you would consistently hit very low in your damage range, even if your range was very wide. This made some conceptual sense, but high firepower mobs never really hit with high damage which rendered them essentially inert opponents",
      "Critical hits were also removed. While they brought a fun element of chance, they were kind of redundant, since chance is already involved in having a high firepower with low accuracy build",
      "Dodging an attack is still based on attacker accuracy vs. defender evasion, but the formula is a lot more simple now. My math skills weren't good enough to handle exponential curves",
      "Hit chance of attacks and skills are now shown in battle tooltips",
    ],
  },
  {
    name: "Sneak peak tweaks",
    date: new Date("1-4-25"),
    changes: [
      "Bugfix: Fixed issue where a few in-battle opponent skills were reflecting the player's stats instead",
      "Add damage reduced by shields to combat logs",
    ],
  },
  {
    name: "(Re)Work Experience",
    date: new Date("12-31-24"),
    changes: [
      "Re-configured how experience works to be a fixed amount per level (1000). Experience given from mobs now depends on the level difference in a battle",
      "Fight preview overlay now shows how much experience and credits you'd gain with each battle rating",
      "Fixed issue where leveling up through an Exp Booster wouldn't let you know that you leveled up or how many medallions you gained, and would cause a weird victory screen in your next battle",
      "Upped battle rating reward multipliers, which applies to how much experience and how many credits you gain from a victory: silver is now 1.2x instead of 1.1x, gold is now 1.5x instead of 1.2x, and platinum is now 2x instead of 1.5x",
    ],
  },
  {
    name: "Long-Term Memory",
    date: new Date("12-26-24"),
    changes: [
      "Combat log now keeps all actions during a battle in a scrollable view, instead of just the latest 5",
      "Reduced Rapidfire skill to 3 minimum damage shots instead of 4",
    ],
  },
  {
    name: "Season's tweakings",
    date: new Date("12-26-24"),
    changes: [
      "On the enhance stats screen, the base stat tooltips now show how much each stat enhancement adds to the actual derived stats",
      "Decreased cost of experience boosters, they were too pricy for the amount of experience",
      "Limited the max quantity of certain items in your inventory (ex: it doesn't make sense to have two Recall Rifts). So now you can't accidentally buy too many",
      "And lastly, sorry for the terrible update title. Happy holidays to you all!",
    ],
  },
  {
    name: "Sneak peek",
    date: new Date("12-23-24"),
    changes: [
      "Added opponent skills to the in-battle screen, with recharge numbers and tooltip info, so you can better track when they might use a skill",
    ],
  },
  {
    name: "Take it to the Limit",
    date: new Date("12-22-24"),
    changes: [
      "Added actual UI for when max level (50) is reached",
      "Limited base stat enhancements to max amount (25). this was done in the UI, but not actually in the logic (oof)",
      "Implemented this changelog - so meta",
    ],
  },
  {
    name: "Mulligan!",
    date: new Date("12-19-24"),
    changes: [
      "Added the ability to switch ship and pilot up to level 5, given players were asked to make a choice on ship/pilot combo before they even knew what the game was. This can be done in the Shipworks and Pilot Guild buildings, for a small credits cost",
      "Also added Recall Rift (the item to teleport back to the city) to the main screen for easier access",
    ],
  },
  {
    name: "Getting Ratio'd",
    date: new Date("12-17-24"),
    changes: [
      "Updated Battle Rating damage ratios to be more reasonable and actually achievable through the right build and strategy. Silver changed from 3:1 to now 2:1. Gold changed from 10:1 to now 5.1 Platinum changed from 40:1 (oof) to now 15:1",
      "Added the actual current damage ratio to the Battle Rating progress bar tooltip",
      "Added the Battle Rating progress bar (final bar in this case) to the Victory overlay",
      "Thank you to Vael Victus for all the playtesting and help with Battle Rating calibrations!",
    ],
  },
  {
    name: "Makeover Montage",
    date: new Date("12-15-24"),
    changes: [
      "Updated the visuals of the 5 player ships to be a little more detailed and interesting to look at since they're on-screen 95% of the time",
    ],
  },
  {
    name: "28 Tweaks Later",
    date: new Date("12-9-24"),
    changes: [
      "Platinum is now 40:1 damage dealt vs. damage taken instead of 20:1 (Don't worry, this gets changed later, because good god this is difficult)",
      "Reduced amount of sell credits that upgrades are worth",
      "Doubled the amount of XP gained by defeating mobs",
      "Doubled the amount of credits gained by defeating mobs",
    ],
  },
  {
    name: "Loss Leader",
    date: new Date("12-7-24"),
    changes: [
      "Removed loss of XP when losing a battle, given the time cost of losing and being sent back to the main city is punishment enough",
      "Thank you to Vael Victus for the suggestion!",
    ],
  },
  {
    name: "Let's Costco it up",
    date: new Date("12-5-24"),
    changes: [
      "Implemented ability to buy or sell in 10x quantities at the Shipworks shop",
      "Added WASD keyboard controls for movement (really just AD, given the very horizontal-ness of Light Voyagers",
    ],
  },
  {
    name: "Total Recall",
    date: new Date("12-4-24"),
    changes: [
      "Added a new supply Recall Rift that allows you to instantly transport back to the main city in a planet (currently one planet) - very MUD inspired",
    ],
  },
  {
    name: "Log about combat ...log",
    date: new Date("12-3-24"),
    changes: [
      "Implemented a combat log describing every fight action, since it's hard to catch every action that happens",
      "Added a Battle Rating progress bar, letting you know what battle rating you're on track for while in battle",
      "Removed now redundant toast messages blocking the battle animations, since those are all now represented in the combat log",
      "Thank you to Dryp for the early playtesting and for the combat log idea!",
    ],
  },
  {
    name: "Checks and Balances",
    date: new Date("12-1-24"),
    changes: [
      "Added player and mob skills to Starship Analysis (fight preview) overlay",
      "Adjusted how previous highest battle rating is shown in the Starship Analysis overlay",
      "Max damage gains on base stats and upgrades reduced slightly",
      "Rapidfire skill now fires four shots, based on the ship's minimum damage stat",
      "Beefed up Resilience on Acela",
      "Critical hit chance threshold is slightly higher (more rare)",
    ],
  },
  {
    name: `"Alpha" Release!`,
    date: new Date("11-30-24"),
    changes: [
      "Core game loop is established, with enough content to playtest",
      "Mobs and drops in Bishop up to level 20",
      "Mobs can now perform same skills as players",
      "Show derived stats when hovering over ship parts bars in battle",
      "Shared on PBBG Reddit and Discord looking for early feedback",
      "Thank you to Bredkrum for the feedback to get the game to this release!",
    ],
  },
];
